<template>
    <div class="mycontract">
        <p class="mb20 bold">我的合同</p>
        <div class="main">
            <div
                class="contract_cell mb20 fr ac"
                v-for="i in contract_list"
                :key="i.order_id"
                @click="gocontractdetail(i.contract_imgs)"
            >
                <img src="/static/imgs/me/contract.png" alt class="img" />
                <div class="fc jsb fg">
                    <div class="fr ac jsb">
                        <p class="bold">{{i.contract_name}}</p>
                        <p>{{i.create_time}}</p>
                    </div>
                    <p class="mt10 fz12">订单号：{{i.order_no}}</p>
                </div>
            </div>
            <div class="fr ac jc">
                <el-pagination
                    :hide-on-single-page="true"
                    :current-page.sync="page"
                    layout="prev, pager, next"
                    :total="total"
                    class="mt20 mb20"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            page: 1,
            total: 0,
            contract_list: []
        };
    },
    computed: {},
    created() {
        this.getOrderContracts();
    },
    watch: {
        page(n) {
            this.getOrderContracts();
        }
    },
    methods: {
        gocontractdetail(img) {
            // 将合同图片存放在session。
            this.set("contract_img", img || "", 1);
            this.go("/contractdetail");
        },
        getOrderContracts() {
            this.post("orderInterfaces/v1.0/getOrderContracts", {
                page: this.page
            }).then(res => {
                this.contract_list = res.data;
                this.total = res.total;
            });
        }
    },
    components: {}
};
</script>

<style scoped lang="scss">
.mycontract {
    font-size: 14px;
    .main {
        .contract_cell {
            width: 100%;
            padding: 20px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
            .img {
                width: 44px;
                height: 44px;
                margin-right: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myContract/index.vue